import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "service";
import { toast } from "sonner";

interface IFormData {
  email: string;
  phone: string;
  firstname: string;
  surname: string;
  other_names: string;
  password: string;
  gender: string;
  family_name: string;
  dob: string;
}

export const useRegister = () => {
  const [formData, setFormData] = useState<IFormData>({
    email: "",
    phone: "",
    firstname: "",
    surname: "",
    other_names: "",
    password: "",
    gender: "",
    family_name: "",
    dob: "",
  });

  const navigate = useNavigate();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate();
  };

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const body = {
        email: formData.email,
        phone: "+" + formData.phone,
        firstname: formData.firstname,
        surname: formData.surname,
        other_names: formData.other_names,
        password: formData.password,
        gender: formData.gender,
        family_name: formData.family_name,
        dob: formData.dob,
      };

      const response = await register(body);
      return response;
    },
    onSuccess: async (data) => {
      toast.success(data.message);
      navigate("/auth");
    },
    onError: (error: any) => {
      const errorResponse = error?.response?.data;

      if (errorResponse?.type === "validation_error") {
        errorResponse.errors.forEach((err: any) => {
          if (err.detail) {
            toast.error(err.detail);
          }
        });
      } else {
        const errorMessage =
          error?.response?.data?.error ||
          error.message ||
          "Failed to register.";

        if (errorMessage.includes("A user with this email already exists.")) {
          toast.error("A user with this email already exists.");
        } else if (
          errorMessage.includes("A user with this phone number already exists.")
        ) {
          toast.error("A user with this phone number already exists.");
        } else {
          toast.error(errorMessage);
        }
      }
    },
  });

  const isFormComplete = () => {
    return (
      formData.email &&
      formData.phone &&
      formData.firstname &&
      formData.surname &&
      formData.other_names &&
      formData.password &&
      formData.gender &&
      formData.family_name &&
      formData.dob
    );
  };

  return {
    formData,
    handleInputChange,
    handleSubmit,
    isPending,
    setFormData,
    isFormComplete,
  };
};
